module.exports = __webpack_public_path__ + "clouds.png?23a7cc8414778ee552b8dfdce614eda4";